"use strict";
var _BookingItemPatch_model;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class BookingItemPatch {
    constructor(itemId, depositCents) {
        _BookingItemPatch_model.set(this, {});
        const model = {
            data: {
                type: 'booking',
                attributes: {
                    booking_items_attributes: [
                        {
                            quantity: 1,
                            item_id: itemId,
                            force_suggested_booking_cost: true,
                            deposit_cents: depositCents,
                        },
                    ],
                },
            },
        };
        tslib_1.__classPrivateFieldSet(this, _BookingItemPatch_model, model, "f");
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _BookingItemPatch_model, "f");
    }
}
exports.default = BookingItemPatch;
_BookingItemPatch_model = new WeakMap();
//# sourceMappingURL=BookingItem.js.map